export default __webpack_public_path__ + "media/images/receiving-collect-icon-f5b20f9a.png";